import * as React from 'react';
import OrdersLayout from "../components/OrdersLayout"

const AcceptedOrders: React.SFC = () => {
    return ( 
        <OrdersLayout/>
     );
}
 
export default AcceptedOrders;